import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';

export const authGuard: CanActivateFn = async (route, state) => {
    const keycloakService = inject(KeycloakService);
    const isAuthenticated = keycloakService.isLoggedIn();
    // console.log(keycloakService.isTokenExpired())
    // console.log(keycloakService.getUsername())
    // console.log(keycloakService.getToken())

    if (!isAuthenticated) {
        // keycloakService.logout();
        // localStorage.clear();
        // sessionStorage.clear();
        await keycloakService.login({
            redirectUri: window.location.origin + state.url
        });
        // return isAuthenticated;
    }
    return isAuthenticated;
};